module.exports = __webpack_public_path__ + "static/media/website-filters.a7a589c0.svg";